import React from 'react';
const angles = [0, 60, 120, 180, 240, 300];
function withRotation(angle, Component) {
    return function (props) {
        return (React.createElement("g", { transform: `rotate(${angle}, ${props.center.x}, ${props.center.y})` },
            React.createElement(Component, { ...props })));
    };
}
export function createVariants(name, Component) {
    const variants = {};
    angles.forEach((angle) => {
        const variantName = createVariantName(name, angle);
        if (angle === 0) {
            variants[variantName] = Component;
        }
        else {
            variants[variantName] = withRotation(angle, Component);
        }
    });
    return variants;
}
function createVariantName(groupName, angle) {
    if (angle === 0) {
        return groupName;
    }
    return `${groupName}Angle${angle}`;
}
export function createListOfAllVariants(basicVariants) {
    return Object.entries(basicVariants).reduce((acc, [name, component]) => {
        if (name === 'default') {
            acc.default = component;
            return acc;
        }
        return {
            ...acc,
            ...createVariants(name, component),
        };
    }, {});
}
export function createVariantGroups(basicVariantNames) {
    const groups = {};
    basicVariantNames.forEach((groupName) => {
        const variants = [];
        if (groupName === 'default') {
            variants.push(groupName);
        }
        else {
            angles.forEach((angle) => {
                variants.push(createVariantName(groupName, angle));
            });
        }
        groups[groupName] = variants;
    });
    return groups;
}
export default withRotation;
